/**
 * The type of (redux) action to update invite list.
 *
 * {
 *     type: UPDATE_CALLABLE_USERS,
 *     token: object
 * }
 */
export const UPDATE_ORGANIZATIONS = 'UPDATE_ORGANIZATIONS';
/**
 * The type of (redux) action to update invite call status
 *
 * {
 *     type: UPDATE_CALL_STATUS,
 *     token: string
 * }
 */
export const UPDATE_CALL_STATUS = 'UPDATE_CALL_STATUS';
/**
 * The type of (redux) action to update invite callee.
 *
 * {
 *     type: UPDATE_CALLEE,
 *     token: object
 * }
 */
export const UPDATE_CALLEE = 'UPDATE_CALLEE';
/**
 * The type of (redux) action to update display call preaprign notification
 *
 * {
 *     type: SET_PREPARING_CALL_NOTIFICATION_UID,
 *     uid: number
 * }
 */
export const SET_CALL_NOTIFICATION_UID = 'SET_CALL_NOTIFICATION_UID';
/**
 * The type of (redux) action to update listener status
 *
 * {
 *     type: IS_LISTENER_ADDED,
 *     uid: number
 * }
 */
export const UPDATE_IS_LISTENER_ADDED = 'UPDATE_IS_LISTENER_ADDED';
